import { render, staticRenderFns } from "./Objectives.vue?vue&type=template&id=4b46d546&scoped=true&"
import script from "./Objectives.vue?vue&type=script&lang=js&"
export * from "./Objectives.vue?vue&type=script&lang=js&"
import style0 from "./Objectives.vue?vue&type=style&index=0&id=4b46d546&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b46d546",
  null
  
)

export default component.exports